module.exports = __webpack_public_path__ + "static/urban3-db83e17a4e3f5abd1809cd04a2583e88.jpg";